import { Injectable } from '@angular/core';

declare let THREE: any;
import { TouchAndMouseMap } from '../Component(2D and 3D)/touch-and-mouse-map';
import { isSecondaryTouchPointer } from '../utils/pointer-input.utils';
import { SceneUtilsService } from './scene-utils.service';
import { StageService } from './stage.service';
import { ObjectCheckerService } from './object-checker.service';
import { UndoService } from './undo.service';
import { Subject, Subscription } from 'rxjs';
import { AwningService } from './awning/awning.service';

@Injectable()
export class Select3dService extends TouchAndMouseMap {
  /** Тап по экрану: палец смещается — порог в px² вместо строгого равенства координат. */
  private static readonly TAP_SLOP_SQ = 40 * 40;

  private _selectedTier: any;
  private _selectedWall: any;
  private _selectedStair: any;
  private _selectedAccessories: Array<any> = [];
  private _selectedAwnings: Array<any> = [];
  private _selectedTrellis: Array<any> = [];
  private _objectRemoveSubscription: Subscription;
  private _wallEmbeddable: any[] = [];
  private _raycaster: any = new THREE.Raycaster();
  selectedTierSubject = new Subject<any>();
  selectedWallSubject = new Subject<any>();
  selectedStairSubject = new Subject<any>();
  selectedAccessorySubject = new Subject<any>();
  selectedAwningSubject = new Subject<any>();
  selectedTrellisSubject = new Subject<any>();
  selectedWindowDoorSubject = new Subject<any>();
  objectSelect = new Subject<any>();
  clearSelected = new Subject<any>();
  mouseX: any;
  mouseY: any;

  constructor(
    private SceneUtilsService: SceneUtilsService,
    private StageService: StageService,
    private objectCheckerSrvc: ObjectCheckerService,
    private undoSrvc: UndoService,
    private awningService: AwningService
  ) {
    super();
    this._objectRemoveSubscription = this.StageService.objectRemoved.subscribe(this.removeDeleted);
  }

  hold(e: MouseEvent) {
    if (isSecondaryTouchPointer(e)) {
      return;
    }
    this.mouseX = e.offsetX;
    this.mouseY = e.offsetY;
  }

  // to do
  // multiple selection
  // of one object type
  release(e: MouseEvent) {
    if (isSecondaryTouchPointer(e)) {
      return;
    }

    this.clearSelection();

    const downX = this.mouseX;
    const downY = this.mouseY;
    if (typeof downX !== 'number' || typeof downY !== 'number') {
      return;
    }
    const dx = e.offsetX - downX;
    const dy = e.offsetY - downY;
    if (dx * dx + dy * dy > Select3dService.TAP_SLOP_SQ) {
      return;
    }

    const p = this.SceneUtilsService.getRay(e.offsetX, e.offsetY);
    this._raycaster.ray.origin.copy(p.ray.origin);
    this._raycaster.ray.direction.copy(p.ray.direction);

    const sceneObjs = [];
    const stage = this.StageService.getScene();
    window['scene'] = stage;
    // console.log('stage', stage);
    stage.traverse(obj => {
      if (obj.visible && this.objectCheckerSrvc.isSelectable(obj)) {
        sceneObjs.push(obj);
      }
    });
    // this.selectedWallSubject.next(null);
    const intersections = this._raycaster.intersectObjects(sceneObjs, true);
    let selectedObject = null;

    if (intersections.length) {
      const firstIntersection = intersections[0];
      // console.log('firstIntersection', firstIntersection);
      let selectedObjectName;

      if (this.objectCheckerSrvc.isWall(firstIntersection.object)) {
        const wallObjects = firstIntersection.object.children;
        const wallObjectsIntersections = this._raycaster.intersectObjects(wallObjects, true);
        if (wallObjectsIntersections.length !== 0) {
          const itersectedObject = wallObjectsIntersections[0].object;
          selectedObject = itersectedObject.parent;
          selectedObjectName = 'embeddable';
        }
      }

      if (!selectedObject) {
        selectedObject = firstIntersection.object;

        while (
          !selectedObject.userData.isDeckComponent &&
          selectedObject.name !== 'Accessory' &&
          selectedObject.name !== 'Awning' &&
          selectedObject.name !== 'Trellis'
        ) {
          selectedObject = selectedObject.parent;
        }

        if (selectedObject.userData.isChildStep) {
          selectedObject = selectedObject.parent;
        }

        selectedObjectName = selectedObject.name;
      }

      switch (selectedObjectName) {
        case 'floor': {
          this._selectedTier = selectedObject;
          this.selectedTierSubject.next(selectedObject);
          break;
        }
        case 'wall': {
          this._selectedWall = selectedObject;
          this.selectedWallSubject.next(selectedObject);
          break;
        }
        case 'stairs': {
          this._selectedStair = selectedObject;
          this.selectedStairSubject.next(selectedObject);
          break;
        }
        case 'Accessory': {
          this._selectedAccessories.length = 0;
          this._selectedAccessories = [];
          this._selectedAccessories.push(selectedObject);
          this.selectedAccessorySubject.next(this._selectedAccessories);
          break;
        }
        case 'Awning': {
          // console.log('selectedawning', selectedObject);
          const isLastInRow = this.awningService.isLastInRow(selectedObject);
          const getSizes = this.awningService.getSizes(selectedObject);
          const isBaseAwning = this.awningService.isBaseAwning(selectedObject);
          const getDirectParent = this.awningService.getDirectParent(selectedObject);
          // console.log('isLastInRow', isLastInRow);
          // console.log('getSizes', getSizes);
          // console.log('isBaseAwning', isBaseAwning);
          // console.log('getDirectParent', getDirectParent);

          const selectedAwning = this.awningService.getBaseAwning(selectedObject);
          this._selectedAwnings = [];
          this._selectedAwnings.push(selectedAwning);
          this.selectedAwningSubject.next(this._selectedAwnings);
          break;
        }
        case 'Trellis': {
          this._selectedTrellis = [];
          this._selectedTrellis.push(selectedObject);
          this.selectedTrellisSubject.next(this._selectedTrellis);
          break;
        }
        case 'embeddable': {
          this._wallEmbeddable.length = 0;
          this._wallEmbeddable.push(selectedObject);
          this.selectedWindowDoorSubject.next(this._wallEmbeddable);
          break;
        }
      }
    }
    this.objectSelect.next(selectedObject);
  }

  disable() {
    this.clearSelection();
    super.disable();
  }

  clearSelection() {
    this._selectedStair = null;
    // this.selectedTier = null;
    this._selectedWall = null;
    // this.selectedAccessories.length = 0;
    this._wallEmbeddable.length = 0;
    this._selectedAwnings.length = 0;
    this._selectedTrellis.length = 0;
    this._selectedAccessories.length = 0;
    this.clearSelected.next();
  }

  getSelectedStair() {
    return this._selectedStair;
  }

  getSelectedTier() {
    return this._selectedTier;
  }

  getSelectedWall() {
    return this._selectedWall;
  }

  setSelectedTier(tier) {
    this._selectedTier = tier;
    this.selectedTierSubject.next(tier);
  }

  getSelectedAccessories() {
    return this._selectedAccessories;
  }

  getSelectedAwnings() {
    return this._selectedAwnings;
  }

  getSelectedTrellis() {
    return this._selectedTrellis;
  }

  getSelectedWallEmbeddable() {
    return this._wallEmbeddable;
  }

  private removeDeleted = (): void => {
    this._selectedAccessories = [];
  };

  dispose() {
    super.dispose();
    this._objectRemoveSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/select-3d.service.ts